<template>
  <div class="main-sidebar main-sidebar-sticky side-menu">
    <div class="sidemenu-logo">
      <router-link class="main-logo" to="/dashboard">
        <h3>Ventourio Admin</h3>
      </router-link>
    </div>
    <div class="main-sidebar-body">
      <ul class="nav">
        <template v-for="(nav, i) in navigation">
          <li class="nav-header" :key="'nav-header-' + i"><span class="nav-label text-capitalize">{{nav.name}}</span></li>
          <template v-for="(link, j) in  nav.links">
            <div v-if="isAdmin(link.isAdmin)" :key="'nav-item-with-sub-'+i+'-'+j">
              <li v-if="link.subMenu && link.subMenu.length" class="nav-item" :class="{'show': link.show}">
                <a class="nav-link with-sub" href="#" @click.prevent="link.show = !link.show">
                  <span class="shape1"></span>
                  <span class="shape2"></span>
                  <i :class="link.icon + ' sidemenu-icon'"></i>
                  <span class="sidemenu-label text-capitalize">{{link.name}}</span>
                  <i class="angle fe fe-chevron-right"></i>
                </a>
                <ul class="nav-sub">
                  <router-link tag="li" :to="subMenuItem.path" class="nav-sub-item" v-for="(subMenuItem, g) in link.subMenu" :key="g">
                    <a href="#" class="nav-sub-link text-capitalize" >{{subMenuItem.name}}</a>
                  </router-link>
                </ul>
              </li>
              <router-link tag="li" :to="link.path" v-else class="nav-item">
                <a class="nav-link" href="#">
                  <span class="shape1"></span>
                  <span class="shape2"></span>
                  <i :class="link.icon + ' sidemenu-icon'"></i>
                  <span class="sidemenu-label text-capitalize">{{link.name}}</span>
                  <span class="ml-3 text-danger" v-if="link.notification && link.notification === 'contact-us'">{{unseenContactUsCount}} + </span>
                  <span class="ml-3 text-danger" v-if="link.notification && link.notification === 'certificate'">{{unseenCertificateCount}} + </span>
                  <span class="ml-3 text-danger" v-if="link.notification && link.notification === 'withdrawal'">{{unseenWithdrawCount}} + </span>
                  <span class="ml-3 text-danger" v-if="link.notification && link.notification === 'transaction'">{{unseenTransactionCount}} + </span>
                </a>
              </router-link>
            </div>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import navigation from '../../utility/navigation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'SideMenu',
  data () {
    return {
      navigation: navigation,
      unseenCertificateCount: 0,
      unseenWithdrawCount: 0,
      unseenTransactionCount: 0,
      unseenContactUsCount: 0
    }
  },
  mounted () {
    this.getDashboardData().then((res) => {
      this.unseenCertificateCount = res.unseenCertificateCount
      this.unseenWithdrawCount = res.unseenWithdrawCount
      this.unseenTransactionCount = res.unseenTransactionCount
      this.unseenContactUsCount = res.unseenContactUsCount
    })
    window.Echo.private('certificates-count').listen('.unseen_certificates_count', (e) => {
      this.unseenCertificateCount = e.unseenCertificateCount
    })
    window.Echo.private('withdrawals-count').listen('.unseen_withdraw_count', (e) => {
      this.unseenWithdrawCount = e.unseenWithdrawCount
    })
    window.Echo.private('transactions-count').listen('.unseen_transaction_count', (e) => {
      this.unseenTransactionCount = e.unseenTransactionCount
    })
    window.Echo.private('contact-us-count').listen('.unseen_contact_us_count', (e) => {
      this.unseenContactUsCount = e.unseenContactUsCount
    })
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  methods: {
    ...mapActions({
      getDashboardData: 'dashboard/getDashboardData'
    }),
    isAdmin (isAdmin) {
      if (!isAdmin) {
        return true
      }
      if (isAdmin && this.user && this.user.roles.find(item => item.guard_name === 'admin')) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style>

</style>
